export default __webpack_public_path__ + "static/media/videogame.6a3ef65f.png";